import {
  FaFacebook, FaInstagram, FaTwitter, FaYoutube,
} from 'react-icons/fa';

const socialLinks = [
  {
    icon: <FaFacebook />,
    name: 'Facebook',
    link: 'https://www.facebook.com',
  },
  {
    icon: <FaTwitter />,
    name: 'Twitter',
    link: 'https://www.twitter.com',
  },
  {
    icon: <FaInstagram />,
    name: 'Instagram',
    link: 'https://www.instagram.com',
  },
  {
    icon: <FaYoutube />,
    name: 'Youtube',
    link: 'https://www.youtube.com',
  },
];

export default socialLinks;
